var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import useWindowSize from "syf-component-library/ui/customHooks/useWindowWidth";
export var CenterContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  background-color: white;\n  flex-direction: column;\n  height: 100%;\n  align-items: center;\n  margin: ", ";\n  max-width: 1248px;\n  border-radius: ", ";\n"], ["\n  display: flex;\n  background-color: white;\n  flex-direction: column;\n  height: 100%;\n  align-items: center;\n  margin: ", ";\n  max-width: 1248px;\n  border-radius: ", ";\n"])), function (_a) {
    var $isLessThanTablet = _a.$isLessThanTablet;
    return ($isLessThanTablet ? "none" : "auto");
}, function (_a) {
    var $isLessThanTablet = _a.$isLessThanTablet;
    return $isLessThanTablet ? "0px" : "6px";
});
var PDFStatementLayout = function (_a) {
    var children = _a.children;
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    return (_jsx(CenterContainer, __assign({ "$isLessThanTablet": isLessThanTablet }, { children: children })));
};
export default PDFStatementLayout;
var templateObject_1;
